module.exports = __webpack_public_path__ + "src/assets/textures/spectro/plane_mat45.jpg";